import InvitationSender from './InvitationSender';
export default InvitationSender;
